import React from 'react';
import { useNavigate } from 'react-router-dom';
import gallery1 from '../../assets/gallery1.png';
import gallery2 from '../../assets/gallery2.png';
import gallery3 from '../../assets/gallery3.png';

const cardData = [
  {
    img: gallery1,
    title: 'Lorem ipsum dolor sit amet cons',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Et lectus quam rhoncus enim nec ultrices blandit. Habitasse Lorem ipsum dolor sit amet....',
  },
  {
    img: gallery2,
    title: 'Lorem ipsum dolor sit amet consectetur.',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Et lectus quam rhoncus enim nec ultrices blandit. Habitasse Lorem ipsum dolor sit amet....',
  },
  {
    img: gallery3,
    title: 'Lorem ipsum dolor sit amet consectetur. Diam gravid fafafa...',
    excerpt:
      'Lorem ipsum dolor sit amet consectetur. Et lectus quam rhoncus enim nec ultrices blandit. Habitasse Lorem ipsum dolor sit amet....',
  },
];

export default function ImageGallery() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-[#F4F3F1] text-stone-800">
      <div className="mx-auto max-w-[1440px] px-8 md:px-16 py-20">

        {/* ── Heading ── */}
        <h2
          className="text-center uppercase tracking-[0.2em] text-[#2c2520]"
          style={{ fontFamily: "'Githera Regular', sans-serif", fontSize: '28px' }}
        >
          Our Journal
        </h2>

        {/* ── Cards ── */}
        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {cardData.map((c, i) => (
            <article key={i} className="flex flex-col items-start">

              {/* Image */}
              <div className="w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={c.title}
                  className="w-full object-cover grayscale"
                  style={{ aspectRatio: '4/3' }}
                  loading="lazy"
                />
              </div>

              {/* Title */}
              <h3
                className="mt-5 text-[14px] font-normal text-[#2c2520] leading-snug"
                style={{ fontFamily: "'Libre Franklin Light', sans-serif" }}
              >
                {c.title}
              </h3>

              {/* Excerpt */}
              <p
                className="mt-3 text-[13px] text-[#6b5c50] leading-relaxed font-light"
                style={{ fontFamily: "'Libre Franklin Light', sans-serif" }}
              >
                {c.excerpt}
              </p>

              {/* Read more */}
              <a
                href="/journal"
                className="mt-4 text-[13px] font-light text-[#2c2520] underline underline-offset-2 decoration-[#2c2520]/40 hover:decoration-[#2c2520] transition-all"
                style={{ fontFamily: "'Libre Franklin Light', sans-serif" }}
              >
                Read more
              </a>
            </article>
          ))}
        </div>

        {/* ── View all button ── */}
        <div className="flex justify-center mt-16">
          <button
            onClick={() => navigate('/journal')}
            className="px-16 py-4 border border-[#2c2520] text-[#2c2520] hover:bg-[#2c2520] hover:text-[#F4F3F1] transition-all duration-300"
            style={{ fontFamily: "'Githera Regular', sans-serif", fontSize: '18px', fontWeight: 400, lineHeight: '100%', letterSpacing: 0 }}
          >
            VIEW ALL ARTICLES
          </button>
        </div>

      </div>
    </section>
  );
}